import axios from '@/lib/axios';
import { LostNonWarrantyRequestParams } from '../types';

const confirmLostNonWarranty = (data: LostNonWarrantyRequestParams) => {
  return axios.post(`/facility/facility_agreements/lost_non_warranty/confirm`, data);
}

export default confirmLostNonWarranty;